import { useEffect, useState } from "react";

const calc = (target) => {
  const t = /[zZ]|[+-]\d\d:\d\d$/.test(target) ? target : `${target}-05:00`;
  const diff = Math.max(0, new Date(t).getTime() - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

export const Countdown = ({ target = "2026-11-03T00:00:00", light = false }) => {
  const [t, setT] = useState(calc(target));
  useEffect(() => {
    const id = setInterval(() => setT(calc(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const tileBase = light
    ? "bg-white/10 backdrop-blur-md border border-white/20 text-white"
    : "bg-navy text-white border border-navy-light/30";

  const units = [
    { label: "Days", value: t.days },
    { label: "Hours", value: t.hours },
    { label: "Minutes", value: t.minutes },
    { label: "Seconds", value: t.seconds },
  ];

  return (
    <div className="flex gap-3 sm:gap-4" data-testid="election-countdown">
      {units.map((u) => (
        <div key={u.label} className={`${tileBase} rounded-xl p-3 sm:p-5 text-center min-w-[70px] sm:min-w-[92px]`}>
          <div className="text-2xl sm:text-4xl font-bold font-serif tabular-nums" data-testid={`countdown-${u.label.toLowerCase()}`}>
            {String(u.value).padStart(2, "0")}
          </div>
          <div className="text-[10px] sm:text-xs uppercase tracking-wider mt-1 opacity-80">{u.label}</div>
        </div>
      ))}
    </div>
  );
};
